/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageAnalysisItemResponse
 */
export interface ImageAnalysisItemResponse {
    /**
     * 
     * @type {string}
     * @memberof ImageAnalysisItemResponse
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageAnalysisItemResponse
     */
    score?: number;
}

/**
 * Check if a given object implements the ImageAnalysisItemResponse interface.
 */
export function instanceOfImageAnalysisItemResponse(value: object): value is ImageAnalysisItemResponse {
    return true;
}

export function ImageAnalysisItemResponseFromJSON(json: any): ImageAnalysisItemResponse {
    return ImageAnalysisItemResponseFromJSONTyped(json, false);
}

export function ImageAnalysisItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageAnalysisItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'score': json['score'] == null ? undefined : json['score'],
    };
}

export function ImageAnalysisItemResponseToJSON(json: any): ImageAnalysisItemResponse {
    return ImageAnalysisItemResponseToJSONTyped(json, false);
}

export function ImageAnalysisItemResponseToJSONTyped(value?: ImageAnalysisItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'score': value['score'],
    };
}

